import { SubscriptionController} from "../controller/SubscriptionController";
//import {ContactController} from "../controller/ContactController";

class Subscription{

    constructor(){

        this.list_categories = [];          //List of categories
        //this.list_contacts = [];            //List of contacts
        this.subscriptionController = new SubscriptionController()

        //Notification params
        this.apiError = {
            status:null,
            message:null
        }


    }


    /**
    * Accessors
    */

     getCategories(){
        return this.list_categories;
    }



    /**
     * PUBLIC FUNCTIONS
     */
    //add category
    async addCategory(category){
        //let subsController = new SubscriptionController();
        let response= await this.subscriptionController.addCategory(category);

        //API call error
        if(response === undefined){
            this.apiError = {
                status: 404,
                message: "Erreur API: Erreur lors de l'ajout de la catégorie"
            }
            return undefined;
        }
        //Connection OK
        if (response.response === '200'){
            
            await this.setCategories();   //update list of categories
            this.apiError = {
                status: null,
                message: null
            }
            return response;
        }
        //Connection KO
        else{
            this.apiError = {
                status: response.response,
                message: response.responseDescription
            }
            return response;
        }


    }


    //Set categories list
     async setCategories(){

        //let subsController = new SubscriptionController();
        let response= await this.subscriptionController.getCategories();

        //API call error
        if(response === undefined){
            this.apiError = {
                status: 404,
                message: "Erreur API: Erreur lors de la récupération des catégories"
            }
            return undefined;
        }
        //Connection OK
        if (response.response === '200'){
            this.list_categories = response.dataArray;
            this.apiError = {
                status: null,
                message: null
            }
            return await response;
        }
        //Connection KO
        else{
            this.list_categories = []
            this.apiError = {
                status: response.response,
                message: response.responseDescription
            }
            return await response;
        }


    }

    //Retrieve the number of contacts by category
    async getCountContactsByCategory(){
        //let subsController = new SubscriptionController();
        let response= await this.subscriptionController.getCountContactsByCategory();

        //API call error
        if(response === undefined){
            this.apiError = {
                status: 404,
                message: "Erreur API: Erreur lors de la récupération des catégories"
            }
            return [];
        }
        //Connection OK
        if (response.response === '200'){
            this.apiError = {
                status: null,
                message: null
            }
            return await response;
        }
        //Connection KO
        else{
            this.apiError = {
                status: response.response,
                message: response.responseDescription
            }
            return await response;
        }
    }


    //Retrieve the list of categories for a given contact id
    async getCategoriesByContactId(contactid){
        let response= await this.subscriptionController.getCategoriesByContactId(contactid);
        //debugger;
        //API call error
        if(response === undefined){
            this.apiError = {
                status: 404,
                message: "Erreur API: Erreur lors de la récupération des catégories associées au contact"
            }
            return [];
        }
        //Connection OK
        if (response.response === '200'){
            this.apiError = {
                status: null,
                message: null
            }
            return await response['dataArray'];
        }
        //Connection KO
        else{
            this.apiError = {
                status: response.response,
                message: response.responseDescription
            }
            return await response;
        }
    }

    //delete category
    async deleteCategory(id){
        //let subsController = new SubscriptionController();
        let response= await this.subscriptionController.deleteCategory(id);

        //API call error
        if(response === undefined){
            this.apiError = {
                status: 404,
                message: "Erreur API: Erreur lors de la suppression de la catégorie"
            }
            return undefined;
        }
        //Connection OK
        if (response.response === '200'){
            
            await this.setCategories();   //update list of categories
            this.apiError = {
                status: null,
                message: null
            }
            return response;
        }
        //Connection KO
        else{
            this.apiError = {
                status: response.response,
                message: response.responseDescription
            }
            return response;
        }


    }


    //update category
    async updateCategory(id, newcategory){
        //let subsController = new SubscriptionController();
        let response= await this.subscriptionController.updateCategory(id, newcategory);

        //API call error
        if(response === undefined){
            this.apiError = {
                status: 404,
                message: "Erreur API: Erreur lors de la modification de la catégorie"
            }
            return undefined;
        }
        //Connection OK
        if (response.response === '200'){
            
            await this.setCategories();   //update list of categories
            this.apiError = {
                status: null,
                message: null
            }
            return response;
        }
        //Connection KO
        else{
            this.apiError = {
                status: response.response,
                message: response.responseDescription
            }
            return response;
        }


    }


    //get Category By Id
    getCategoryById = async (id) => {
        


        //On récupère la liste des contacts associés à la catégorie
        let contactsCategory = await this.__getContactsIdFromCategory(id);

        //On Récupère les infos de la catégorie
        let _ = require("underscore");

        let filter = _.filter(this.list_categories, function(item){
            return item.id === id;
        });  

        let category = {};
        if (filter.length > 0){
            category =  filter[0];
        }
        
        category['contacts'] = contactsCategory

        return category;


    }


    //Update users subscriptions
    async updateUsersSubscrption(subscription_id, contact_ids_toremove, contacts_ids_toadd){
        //let subsController = new SubscriptionController();
        let response= await this.subscriptionController.updateSubscriptionUsers(subscription_id,contact_ids_toremove,contacts_ids_toadd);

        //API call error
        if(response === undefined){
            this.apiError = {
                status: 404,
                message: "Erreur API: Erreur lors de la mise à jour des abonnements utilisateur"
            }
            return undefined;
        }
        //Connection OK
        if (response.response === '200'){
            
            this.apiError = {
                status: null,
                message: null
            }
            return response;
        }
        //Connection KO
        else{
            this.apiError = {
                status: response.response,
                message: response.responseDescription
            }
            return response;
        }
    }

    //Store all contacts in this.list_contacts
    /*async setContacts(){
        let contactController = new ContactController();
        let response= await contactController.getContacts()

        //API call error
        if(response === undefined){
            this.apiError = {
                status: 404,
                message: "Erreur API: Erreur lors de la récupération des contacts"
            }
            return undefined;
        }
        //Connection OK
        if (response.response === '200'){
            this.list_contacts = response.dataArray;
            this.apiError = {
                status: null,
                message: null
            }
            return await response;
        }
        //Connection KO
        else{
            this.list_contacts = []
            this.apiError = {
                status: response.response,
                message: response.responseDescription
            }
            return await response;
        }
    }*/


    /**
     * PRIVATE FUNCTIONS
     */
    //get contacts id from a category
    async __getContactsIdFromCategory(categoryid){
        //let subsController = new SubscriptionController();
        let response= await this.subscriptionController.getCategoryContacts(categoryid);

        //API call error
        if(response === undefined){
            this.apiError = {
                status: 404,
                message: "Erreur API: Erreur lors de la récupération des contacts de la catégorie"
            }
            return undefined;
        }
        //Connection OK
        if (response.response === '200'){
            this.apiError = {
                status: null,
                message: null
            }
            return await response.dataArray;
        }
        //Connection KO
        else{
            this.list_contacts = []
            this.apiError = {
                status: response.response,
                message: response.responseDescription
            }
            return await response;
        }



    }


}
export default Subscription;